import { Event } from 'src/WebApiController';

export const getIsPlaceholderEvent = (event: Event): boolean => {
  const length = event.placeholders?.length ?? 0;
  return length > 0;
};
